export default {
  nearby: {
    name: 'nearby',
    tab_name: '最近的巴士站',
    url: 'closest',
    mode: 'closestRoute',
  },
  p2p: {
    name: 'p2p',
    tab_name: '點對點',
    url: 'p2p',
    mode: 'p2pTab',
  },
  info: {
    name: 'info',
    tab_name: '路線搜尋',
    url: 'info',
    mode: 'routeinfoBase',
  },
};
